export default function formatDocument(cep) {
  const cepAtualizado = cep.replace(/(\d{5})(\d{3})/,
    (regex, argumento1, argumento2) => `${argumento1}-${argumento2}`);
  return cepAtualizado;
}
